var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCouponApplied = function SvgCouponApplied(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 14.3 14.3"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    "data-name": "Group 3805"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.15.65a6.5 6.5 0 1 1-6.5 6.5 6.5 6.5 0 0 1 6.5-6.5",
    "data-name": "Path 18912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.507 7.15 6.27 8.912l3.524-3.524",
    "data-name": "Path 18911"
  }))));
};
export default SvgCouponApplied;